import { CircleGauge, CloudOff, Radio } from 'lucide-react'
import type { ReactNode } from 'react'
import { useDemoStore } from '../../store'

export function PageTitle({ title, copy, actions }: { title: string; copy: string; actions?: ReactNode }) {
  return <div className="app-page-title"><div><h1>{title}</h1><p>{copy}</p></div>{actions && <div className="app-page-title__actions">{actions}</div>}</div>
}

export function DemoNotice() {
  const { apiMode, apiError, lastRefresh, refreshLiveData } = useDemoStore()

  if (apiMode === 'live') {
    return <div className="demo-notice"><Radio size={16} /><span><strong>Local live mode.</strong> Workflow runs and approvals are stored in Tenant 001 D1. External send, publish, spend and destructive actions remain disabled.{lastRefresh ? ` Last refreshed ${new Date(lastRefresh).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}.` : ''}</span><button className="text-button" onClick={() => void refreshLiveData()}>Refresh</button></div>
  }

  if (apiMode === 'connecting') {
    return <div className="demo-notice"><CircleGauge size={16} /><span>Connecting to the local Tenant 001 control plane…</span></div>
  }

  return <div className="demo-notice"><CloudOff size={16} /><span><strong>Offline preview mode.</strong> Start the Worker on port 8787 to record real workflow runs.{apiError ? ` ${apiError}` : ''}</span><button className="text-button" onClick={() => void refreshLiveData()}>Retry</button></div>
}

export function StatusBadge({ children, tone = 'neutral' }: { children: ReactNode; tone?: 'good' | 'warn' | 'danger' | 'neutral' }) {
  return <span className={`status-badge status-badge--${tone}`}>{children}</span>
}
